import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const container = document.getElementById("root");
const root = createRoot(container);

// Set scroll restoration to manual so the browser never restores previous scroll positions
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
